<template>
  <div>
    <v-container fluid fill-height>
      <v-card-text class=" text-xs-center text-md-center text-lg-center">
        <div class="headline primary--text font-weight-bold">
          <span v-if="loading">{{
            $t("screener.login_link.loader.message")
          }}</span>
          <div v-else-if="error_message">{{$t("screener.login_link.error.message")}}
          <br/>
          <small>{{error_message}}</small>
          </div>
        </div>
      </v-card-text>
    </v-container>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "LoginLink",
  data() {
    return {
      loading: false,
      error_message: null
    };
  },
  async beforeRouteEnter(to, from, next) {
    await next(vm => {
      vm.loginWithLink();
    });
  },
  computed:{
    ...mapState({
      company: (state) => state.company.company,
    }),
  },
  methods: {
    async loginWithLink() {
      this.loading = true;
      try {
        var response  = await this.$store.dispatch("auth/verifyOTP", {
            key: this.$route.params.session_key,
            otp: this.$route.params.otp,
            company_id: this.company.id,
        })
        await this.handleRedirection();
      } catch (error) {
        this.$store.dispatch("app/showMessage", {
          message:error.message,
          color:"error"
        });
        this.error_message = error.message;
      }finally{
        this.loading = false;
      }
    },
    async handleRedirection(){
      if(this.$route.query && this.$route.query.redirectTo){
        var redirectTo = this.$route.query.redirectTo;
        this.$router.push(redirectTo)
      }else{
        this.goToCompanyHome();
      }
    },
    goToCompanyHome() {
      this.$router.push({
        name: "company.dashboard",
      });
    },
  }
};
</script>
